import axios from 'axios';

export default {
  props: ['item'],
  data() {
    return {
      addresses: null,
      address: '',
    };
  },
  methods: {
    AutocompleteSearch(queryString, cb) {
      if (!queryString) return;
      const app = this;
      const info = { count: 20, query: queryString };
      const config = {
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
          'Content-Type': 'application/json',
        },
      };

      axios.post('https://dadata.ru/api/v2/suggest/address', info, config)
        .then((res) => {
          app.suggestions = res.data.suggestions;
          cb(app.suggestions);
        })
        .catch(err => console.error(err));
    },
    AutocompleteSelect(item, dealer) {
      const app = this;
      this.suggestions.forEach((sug) => {
        if (sug.value === item.value) {
          this.addresses = sug.data;
          this.$emit('change', dealer.id, app.address, sug.data);
        }
      });
    },
    Clear() {
      this.$emit('change', this.$props.item.id, '', null);
    },
  },
};
